import { render, staticRenderFns } from "./P-Video.vue?vue&type=template&id=613f4be1&lang=pug&"
import script from "./P-Video.vue?vue&type=script&lang=js&"
export * from "./P-Video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports